export const getPersonsCount = (adults: number | null, children: number | null) => {
    if (!adults && !children) {
        return 0
    } else if (!children) {
        return adults
    } else if (adults) {
        return adults + children
    } else {
        return children
    }
}
